import Events from '@/services/Events';
// @ts-expect-error: Declare GLTFLoader
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import type { ILoadedModel } from '@/commons/assetsManager/ILoadedModel';

class ModelLoader {
    private static _instance: ModelLoader; // eslint-disable-line

    private _loaderUtils = {
        gltf: new GLTFLoader(),
    };

    private _meshes: [ILoadedModel | null] = [null];

    private static get getInstance(): ModelLoader {
        if (!ModelLoader._instance) {
            ModelLoader._instance = new ModelLoader();
        }

        return ModelLoader._instance;
    }

    public static loadModel(modelPath: string): ILoadedModel {
        return ModelLoader.getInstance._loadModel(modelPath);
    }

    public static loadModels(modelsPath: string[]): ILoadedModel[] {
        return ModelLoader.getInstance._loadModels(modelsPath);
    }

    public static get meshes(): [ILoadedModel | null] {
        return ModelLoader.getInstance._meshes;
    }

    public static getNameFromPath(path: string) {
        const name = path?.split('/').pop();
        if (!name) {
            return '';
        }

        return name.split('.')[0];
    }

    private _loadModel(modelPath: string): ILoadedModel {
        const name = ModelLoader.getNameFromPath(modelPath);
        const isMeshLoaded = this._meshes.find((loadedModel) => loadedModel?.name === name);
        if (isMeshLoaded) {
            return isMeshLoaded;
        }
        // @ts-ignore
        const loadedModel = {
            name,
            model: null,
        } as ILoadedModel;
        loadedModel.promise = new Promise((resolve, reject) => {
            Events.emit('loading-start', name);
            this._loaderUtils.gltf.load(
                modelPath,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (gltf: any) => {
                    // loadedModel.model.name = name;
                    // loadedModel.model.add(gltf.scene);
                    loadedModel.model = gltf;

                    resolve(loadedModel.model); // return model just in case
                },
                (event: ProgressEvent) => {
                    const progress = (event.loaded / event.total) * 100;
                    Events.emit('loading-progress', { name, progress });
                }, // onProgress
                (errorMsg: unknown) => {
                    reject(new Error(errorMsg as string));
                },
            );
        });

        loadedModel.promise.then(() => {
            Events.emit('loading-end', name);
        });
        this._meshes.push(loadedModel);

        return loadedModel;
    }

    public static init() {
        return ModelLoader.getInstance;
    }

    private _loadModels(modelsPath: string[]): ILoadedModel[] {
        return modelsPath.map((modelPath) => this._loadModel(modelPath));
    }
}

export default ModelLoader;
